import React from 'react';
import { formatContentForDisplay } from '@/utils/contentParserV2';

/**
 * ContentParser parses and renders content that may contain the legacy
 * `doc(paragraph(...))` syntax, converting it to plain display text.
 */
interface ContentParserProps {
  content: string;
  className?: string;
}

export const ContentParser: React.FC<ContentParserProps> = ({ content, className = '' }) => {
  if (!content) {
    return null;
  }

  const parsedContent = formatContentForDisplay(content);

  if (!parsedContent) {
    return null;
  }

  return <span className={className}>{parsedContent}</span>;
};

export default ContentParser;
